import React from "react"
import { CalcForm, Label, Input, ErrorMessage } from "../styles/TopSection.styled"

function onlyNumbers(str) {
  return /^(|[1-9]\d*)$/.test(str);
}

const TopSection = ({ isDetail, employees, setEmployees, formSubmitted, error, showError, setShowError }) => {
  const updateEmployees = (e) => {
    if (onlyNumbers(e.target.value)) {
      setEmployees(e.target.value)
      setShowError(false)
    }
  }

  switch (isDetail) {
    case true : 
      return (
        <>{!formSubmitted && <ErrorMessage>Please complete the ROI calculator and submit your information to view the detailed report.</ErrorMessage>}</>
      )
    default : 
      return (
        <CalcForm>
          <Label htmlFor="employees">How many employees are in your organization?</Label>
          <Input 
            id="employees"
            value={employees} 
            onChange={e => updateEmployees(e)}
            placeholder="Number of employees in your organization"
            />
          {showError && <ErrorMessage label>{error}</ErrorMessage>}
        </CalcForm>
      )
  }
}

export default TopSection
